import { useTheme } from '@mui/material/styles';

// MUI-compatible color palettes
export const DEFAULT_CHART_COLORS = [
  '#1976d2', // Primary blue
  '#d32f2f', // Error red
  '#388e3c', // Success green
  '#f57c00', // Warning orange
  '#7b1fa2', // Purple
  '#0288d1', // Light blue
  '#f44336', // Red
  '#4caf50', // Green
  '#ff9800', // Orange
  '#9c27b0', // Deep purple
  '#03a9f4', // Light blue
  '#e91e63', // Pink
  '#8bc34a', // Light green
  '#ffc107', // Amber
  '#673ab7', // Deep purple
];

export const ACCESSIBILITY_COLORS = [
  '#0173b2', // Blue
  '#de8f05', // Orange
  '#cc78bc', // Pink
  '#ca9161', // Brown
  '#fbafe4', // Light pink
  '#949494', // Gray
  '#ece133', // Yellow
  '#56b4e9', // Sky blue
  '#f0e442', // Yellow
  '#009e73', // Green
];

export const PASTEL_COLORS = [
  '#FFB6C1', // Light pink
  '#87CEEB', // Sky blue
  '#DDA0DD', // Plum
  '#98FB98', // Pale green
  '#F0E68C', // Khaki
  '#FFA07A', // Light salmon
  '#20B2AA', // Light sea green
  '#87CEFA', // Light sky blue
  '#FF69B4', // Hot pink
  '#32CD32', // Lime green
];

// Hook to get theme-aware chart configuration
export const useChartTheme = () => {
  const theme = useTheme();

  return {
    colors: {
      default: DEFAULT_CHART_COLORS,
      accessibility: ACCESSIBILITY_COLORS,
      pastel: PASTEL_COLORS,
    },
    text: {
      primary: theme.palette.text.primary,
      secondary: theme.palette.text.secondary,
    },
    background: {
      paper: theme.palette.background.paper,
      default: theme.palette.background.default,
    },
    grid: {
      line: theme.palette.divider,
    },
    tooltip: {
      background: theme.palette.background.paper,
      border: theme.palette.divider,
      shadow: theme.shadows[4],
    },
  };
};

// Common chart props that work well with MUI theme
export const getBaseChartProps = (_theme: ReturnType<typeof useChartTheme>) => ({
  style: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

// Responsive chart dimensions
export const CHART_DIMENSIONS = {
  small: { width: 300, height: 200 },
  medium: { width: 400, height: 300 },
  large: { width: 500, height: 400 },
  responsive: { width: '100%', height: 300 },
} as const;

// Chart margin configurations
export const CHART_MARGINS = {
  default: { top: 20, right: 30, left: 20, bottom: 5 },
  withLegend: { top: 20, right: 30, left: 20, bottom: 40 },
  withLabels: { top: 20, right: 50, left: 50, bottom: 40 },
} as const;
